import { Spinner } from "@material-tailwind/react";

export const CardLoadingState = () => {
  return (
    <div className="flex min-h-96 items-center justify-center">
      <Spinner height={70} width={70} />
    </div>
  );
};
